import "./Content.css";
import React, { useContext, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { TitleContext } from "../../context/TitleContext";
import { Header } from "../Header/Header";
import { Footer } from "../Footer/Footer";
import { isDeviceMobile } from "../../helpers/deviceDetector";
import { MobileOnly } from "../MobileOnly/MobileOnly";
import { routeNames } from "../../constants/routeNames";
import { useLocation } from "react-router-dom";

const desktopStyleSheet = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
};

const desktopAvailableRoutes = [routeNames.TERMS];

export const Content = (props) => {
  const { title } = useContext(TitleContext);
  const { pathname } = useLocation();
  const isMobile = isDeviceMobile(navigator.userAgent);

  return (
    <Row as={"main"} className="mx-0 px-0">
      <Header />
      <Col lg={4} sm={12} className="content-box" id="content-box">
        <div
          className="page-box"
          style={
            isMobile || desktopAvailableRoutes.includes(pathname)
              ? {}
              : desktopStyleSheet
          }
        >
          {title && (
            <h1 className="slug" lang="en">
              {title}
            </h1>
          )}
          {isMobile || desktopAvailableRoutes.includes(pathname) ? (
            props.children
          ) : (
            <MobileOnly />
          )}
        </div>
      </Col>
      <Footer />
    </Row>
  );
};
